import Afiche from "./Afiche"

const Day = (props: any) : JSX.Element => {
  return <Afiche /> 
}
 

export default Day